import { type IconComponent } from "~/features/ui/icon";
import { fragment } from "~/features/ui/link/utils";
import { useFragment, type FragmentType } from "~/gql/runtime";
import ArrowTopRight from "~/public/icons/arrow-top-right.svg";
import ArrowRight from "~/public/icons/arrow-right.svg";

export function useLinkIcon(link?: FragmentType<typeof fragment>): IconComponent | undefined {
  const _link = useFragment(fragment, link);

  if (!_link) {
    return;
  }

  if (_link.newWindow) {
    return ArrowTopRight;
  }

  return ArrowRight;
}
